import { createReducer } from '../../store.model';
import { Reload, ReloadResult } from '../main/state/reload.action';

import { ActionType } from './landing.action';
import { defaultState, LandingState } from './landing.state';
import {
    ChangeDateRange,
    ChangeDateRangeResult,
} from './state/change-date-range.action';
import {
    changeDateRangeReducer,
    changeDateRangeResultReducer,
} from './state/change-date-range.reducer';
import { FilterRows } from './state/filter-rows.action';
import { filterRowsReducer } from './state/filter-rows.reducer';
import { reloadReducer, reloadResultReducer } from './state/reload.reducer';
import { ResetGrid } from './state/reset-grid.action';
import { resetGridReducer } from './state/reset-grid.reducer';
import { SortRows } from './state/sort-rows.action';
import { sortRowsReducer } from './state/sort-rows.reducer';
import { ToggleGridShowAll } from './state/toggle-grid-show-all.action';
import { toggleGridShowAllReducer } from './state/toggle-grid-show-all.reducer';

const { reducer, builder } = createReducer<ActionType, LandingState>(
    defaultState(),
);

builder
    .add<Reload>(ActionType.EVAL_LANDING__RELOAD, reloadReducer)
    .add<ReloadResult>(
        ActionType.EVAL_LANDING__RELOAD_RESULT,
        reloadResultReducer,
    );

builder
    .add<ChangeDateRange>(
        ActionType.EVAL_LANDING__CHANGE_DATE_RANGE,
        changeDateRangeReducer,
    )
    .add<ChangeDateRangeResult>(
        ActionType.EVAL_LANDING__CHANGE_DATE_RANGE_RESULT,
        changeDateRangeResultReducer,
    );

builder.add<ToggleGridShowAll>(
    ActionType.EVAL_LANDING__TOGGLE_GRID_SHOW_ALL,
    toggleGridShowAllReducer,
);

builder.add<SortRows>(ActionType.EVAL_LANDING__SORT_ROWS, sortRowsReducer);

builder.add<FilterRows>(
    ActionType.EVAL_LANDING__FILTER_ROWS,
    filterRowsReducer,
);

builder.add<ResetGrid>(ActionType.EVAL_LANDING__RESET_GRID, resetGridReducer);

export const landingReducer = reducer;
